import { MassageReservationExpiredModal } from "@app/modals/MassageReservationExpiredModal/MassageReservationExpiredModal"
import { useGetStrings } from "@app/store/service/cmsService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useEffect, useRef, useState } from "react"
import "./MassageReservationTimer.css"

export const MassageReservationTimer = () => {
	const {
		data: { massageFunnelMassageReservationTimer },
	} = useGetStrings(undefined, { defaultData: {} })

	const modal = useModal()
	const massages = useSelector(state => state.order.massages)
	const shoppingCart = useSelector(state => state.order.shoppingCart)
	const selectedMassages = [...massages, ...shoppingCart.filter(e => e.typeId === ORDER_LINE_TYPES.Activity)]
	const codeRef = useRef("")

	const endTime = useSelector(state => {
		const massages = [...state.order.massages, ...state.order.shoppingCart.filter(e => e.typeId === ORDER_LINE_TYPES.Activity)]
		const sorted = massages.sort((a, b) => {
			return new Date(a.bookingLifeTimeEnd).getTime() - new Date(b.bookingLifeTimeEnd).getTime()
		})
		return sorted.length > 0 ? sorted[0].bookingLifeTimeEnd : undefined
	})
	const [remainingTime, setRemainingTime] = useState("")
	const expirationTime = useRef(new Date(endTime).getTime())

	useEffect(() => {
		if (endTime) {
			const expiration = new Date(endTime)
			if (!isNaN(expiration.getTime())) {
				expirationTime.current = expiration.getTime()
			}
		}
	}, [endTime])

	useEffect(() => {
		const sorted = selectedMassages.sort((a, b) => {
			return new Date(a.bookingLifeTimeEnd).getTime() - new Date(b.bookingLifeTimeEnd).getTime()
		})
		if (selectedMassages.length > 0) {
			const scanCodeLink = sorted[0].scanCodeLink
			codeRef.current = scanCodeLink
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedMassages.length])

	useEffect(() => {
		let interval
		if (endTime != undefined) {
			const update = () => {
				const startTime = new Date().getTime()
				const diff = expirationTime.current - startTime
				setRemainingTime(diff)
				if (diff < 0) {
					const scanCode = codeRef.current
					modal.showModal(MassageReservationExpiredModal, { scanCode })
					clearInterval(interval)
					return
				}
			}

			interval = setInterval(update, 1000)
			update()
		}

		return () => {
			clearInterval(interval)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [endTime, massageFunnelMassageReservationTimer])

	//We change the height of the content container to avoid a scrollbar when the timer gets called
	useEffect(() => {
		const content = document.getElementById("content")
		if (endTime) {
			content.style.height = "calc(100% - 24px)"
		} else {
			content.style.height = "100%"
		}
	}, [endTime])

	if (!endTime) return null
	if (remainingTime < 0) return
	const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
	const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)

	return (
		<>
			{massages > 0 || (
				<div className="massageReservationTimer flex-center color-bg-red-100 color-fg-red-500 w-100 mr-3 font-size-5 ml-auto">
					<div className="massageReservationTimer__text ml-2">
						{`${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")} - ${massageFunnelMassageReservationTimer} `}
					</div>
				</div>
			)}
		</>
	)
}
